// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"CreateNewProfile_infoIcon__AqgBz","infoPopup":"CreateNewProfile_infoPopup__3mg88","address":"CreateNewProfile_address__OVw6U"};